import { Box, styled } from '@mui/material';

const TopSection = styled(Box)(
  ({ theme }) => `
        margin: ${theme.spacing(2, 3)};
`
);
export default TopSection;
